import React from 'react';

import Styles from './Title.module.scss';

import type { DateTime } from 'luxon';

import { format } from '@/app/utils/date';

interface Props extends React.ComponentPropsWithRef<'span'> {
	date: DateTime;
	isValid?: boolean;
}

const Title = ({ date, isValid = true, ...props }: Props) => {
	return (
		<span {...props} className={`${Styles.container} ${!isValid ? Styles.invalid : ''}`}>
			{format(date, 'MMMM')}
			<span>{format(date, 'yyyy')}</span>
		</span>
	);
};

export default Title;
